module.exports = __webpack_public_path__ + "img/example_qr_code.fe0c53d0.png";